import { useZoomDetector } from 'common/Hooks/useZoomDetector'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import StlViewer from './StlViewer/StlViewer'

export const ResponsiveGeometryViewer = (props) => {

	const partFiles = useSelector((/** @type {StoreState} */state) => state.CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === props.partId)?.fileLinks)
	const modelSrc = partFiles?.stlModel ?? partFiles?.objModel
	const stepModelSrc = partFiles?.stepModel

	const SIZE_MULTIPLIER_WIDTH = 0.8
	const SIZE_MULTIPLIER_HEIGHT = 0.8

	const [windowSize, setWindowSize] = useState({
		width: window.innerWidth * SIZE_MULTIPLIER_WIDTH,
		height: window.innerHeight * SIZE_MULTIPLIER_HEIGHT,
	})

	const { zoomLevel } = useZoomDetector()

	const handleResize = () => {
		setWindowSize({
			width: window.innerWidth * SIZE_MULTIPLIER_WIDTH,
			height: window.innerHeight * SIZE_MULTIPLIER_HEIGHT,
		})
	}

	useEffect(() => {
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		setWindowSize({
			width: window.innerWidth * SIZE_MULTIPLIER_WIDTH,
			height: window.innerHeight * SIZE_MULTIPLIER_HEIGHT,
		})
	}, [zoomLevel])

	return (
		<StlViewer
			modelSrc={modelSrc}
			stepModelSrc={stepModelSrc}
			windowSize={windowSize}
			partName={props.partName}
			partId={props.partId}
			size={props.size}
			weight={props.weight}
			stepAnalysis={props.stepAnalysis}
		/>
	)
}
